@use '@dixa/lib-shared-tokens/scss' as *;

.root {
  position: absolute;
  justify-content: end;
  top: var(--dixa-size-spacer-100);
  right: var(--dixa-size-spacer-250);
}

.tooltip {
  max-width: 260px;
}
